export enum ProductType {
  PRODUCT = 'product',
  COMPLEMENT = 'complement',
  CONSUMPTION = 'consumption',
}

export interface Product {
  id: string;
  name: string;
  price: number;
  type: ProductType;
}
